import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { PersistGate } from "redux-persist/integration/react";

import "i18n";
import App from "pages/app";
import store, { persistor } from "redux/store";
import InterceptorProvider from "contexts/with-interceptor-provider";
import "assets/css/index.scss";

const Root = () => {
    return (
        <React.StrictMode>
            <Provider store={store}>
                <InterceptorProvider>
                    <PersistGate loading={null} persistor={persistor}>
                        <HelmetProvider>
                            <App />
                        </HelmetProvider>
                    </PersistGate>
                </InterceptorProvider>
            </Provider>
        </React.StrictMode>
    );
};

ReactDOM.render(<Root />, document.getElementById("root"));
